import styled from "styled-components";

export const WppLink = styled.a`
  :hover {
    transform: scale(1.1);
    transition: transform 0.5s;
  }
`;
